// import React, { useEffect, useState } from "react";

// import {
//   collection,
//   onSnapshot,
//   doc,
//   updateDoc,
//   deleteDoc,
// } from "firebase/firestore";

// import {
//   FaSearch,
//   FaPhone,
//   FaEnvelope,
//   FaWhatsapp,
//   FaTrash,
//   FaEye,
//   FaTimes,
//   FaFileInvoiceDollar,
//   FaUser,
//   FaMapMarkerAlt,
//   FaRulerCombined,
//   FaCommentAlt,
// } from "react-icons/fa";

// import { db } from "../../../firebase/firebase";

// import "./QuoteRequests.css";

// const QuoteRequests = () => {
//   const [requests, setRequests] = useState([]);
//   const [search, setSearch] = useState("");
//   const [loading, setLoading] = useState(true);
//   const [selectedRequest, setSelectedRequest] = useState(null);

//   // ==========================================
//   // FIREBASE LISTENER
//   // ==========================================

//   useEffect(() => {
//     const requestsRef = collection(db, "quoteRequests");

//     const unsubscribe = onSnapshot(
//       requestsRef,
//       (snapshot) => {
//         const data = snapshot.docs.map((item) => ({
//           id: item.id,
//           ...item.data(),
//         }));

//         // Sort newest first
//         data.sort((a, b) => {
//           const dateA = getTime(a.createdAt);
//           const dateB = getTime(b.createdAt);

//           return dateB - dateA;
//         });

//         setRequests(data);
//         setLoading(false);
//       },
//       (error) => {
//         console.error("Error loading quote requests:", error);

//         setLoading(false);
//       },
//     );

//     return () => unsubscribe();
//   }, []);

//   // ==========================================
//   // FIRESTORE DATE
//   // ==========================================

//   const getTime = (timestamp) => {
//     if (!timestamp) {
//       return 0;
//     }

//     if (typeof timestamp.toDate === "function") {
//       return timestamp.toDate().getTime();
//     }

//     if (timestamp.seconds) {
//       return timestamp.seconds * 1000;
//     }

//     return new Date(timestamp).getTime() || 0;
//   };

//   // ==========================================
//   // FORMAT DATE
//   // ==========================================

//   const formatDate = (timestamp) => {
//     if (!timestamp) {
//       return "No date";
//     }

//     let date;

//     if (typeof timestamp.toDate === "function") {
//       date = timestamp.toDate();
//     } else if (timestamp.seconds) {
//       date = new Date(timestamp.seconds * 1000);
//     } else {
//       date = new Date(timestamp);
//     }

//     if (isNaN(date.getTime())) {
//       return "No date";
//     }

//     return date.toLocaleString("en-IN", {
//       day: "2-digit",
//       month: "short",
//       year: "numeric",
//       hour: "2-digit",
//       minute: "2-digit",
//     });
//   };

//   // ==========================================
//   // UPDATE STATUS
//   // ==========================================

//   const updateStatus = async (id, status) => {
//     try {
//       await updateDoc(doc(db, "quoteRequests", id), {
//         status: status,
//       });
//     } catch (error) {
//       console.error("Error updating quote status:", error);

//       alert("Unable to update request status.");
//     }
//   };

//   // ==========================================
//   // DELETE REQUEST
//   // ==========================================

//   const handleDelete = async (id) => {
//     const confirmDelete = window.confirm(
//       "Are you sure you want to delete this quote request?",
//     );

//     if (!confirmDelete) {
//       return;
//     }

//     try {
//       await deleteDoc(doc(db, "quoteRequests", id));

//       if (selectedRequest && selectedRequest.id === id) {
//         setSelectedRequest(null);
//       }
//     } catch (error) {
//       console.error("Error deleting quote request:", error);

//       alert("Unable to delete this request.");
//     }
//   };

//   // ==========================================
//   // SEARCH
//   // ==========================================

//   const filteredRequests = requests.filter((request) => {
//     const searchText = search.toLowerCase();

//     return (
//       String(request.name || "")
//         .toLowerCase()
//         .includes(searchText) ||
//       String(request.email || "")
//         .toLowerCase()
//         .includes(searchText) ||
//       String(request.phone || "")
//         .toLowerCase()
//         .includes(searchText) ||
//       String(request.sport || "")
//         .toLowerCase()
//         .includes(searchText) ||
//       String(request.city || request.location || "")
//         .toLowerCase()
//         .includes(searchText)
//     );
//   });

//   // ==========================================
//   // LOADING
//   // ==========================================

//   if (loading) {
//     return (
//       <div className="quote-loading">
//         <div className="quote-spinner"></div>

//         <p>Loading quote requests...</p>
//       </div>
//     );
//   }

//   // ==========================================
//   // PAGE
//   // ==========================================

//   return (
//     <div className="quote-page">
//       {/* ======================================
//           HEADER
//       ====================================== */}

//       <div className="quote-header">
//         <div>
//           <div className="quote-title-row">
//             <FaFileInvoiceDollar />

//             <h2>Quote Requests</h2>
//           </div>

//           <p>Manage customer quote enquiries from your website.</p>
//         </div>

//         <div className="quote-total">
//           <strong>{requests.length}</strong>

//           <span>Total Requests</span>
//         </div>
//       </div>

//       {/* ======================================
//           TOOLBAR
//       ====================================== */}

//       <div className="quote-toolbar">
//         <div className="quote-search">
//           <FaSearch />

//           <input
//             type="text"
//             placeholder="Search by name, email, phone, sport or location..."
//             value={search}
//             onChange={(e) => setSearch(e.target.value)}
//           />
//         </div>

//         <div className="quote-count">
//           {filteredRequests.length}{" "}
//           {filteredRequests.length === 1 ? "Request" : "Requests"}
//         </div>
//       </div>

//       {/* ======================================
//           EMPTY STATE
//       ====================================== */}

//       {filteredRequests.length === 0 && (
//         <div className="quote-empty">
//           <div className="quote-empty-icon">
//             <FaFileInvoiceDollar />
//           </div>

//           <h3>{search ? "No Requests Found" : "No Quote Requests Yet"}</h3>

//           <p>
//             {search
//               ? "Try another search."
//               : "Customer quote enquiries will appear here."}
//           </p>
//         </div>
//       )}

//       {/* ======================================
//           REQUESTS
//       ====================================== */}

//       {filteredRequests.length > 0 && (
//         <div className="quote-table-wrapper">
//           <table className="quote-table">
//             <thead>
//               <tr>
//                 <th>Customer</th>

//                 <th>Contact</th>

//                 <th>Project</th>

//                 <th>Location</th>

//                 <th>Date</th>

//                 <th>Status</th>

//                 <th>Actions</th>
//               </tr>
//             </thead>

//             <tbody>
//               {filteredRequests.map((request) => (
//                 <tr key={request.id}>
//                   {/* CUSTOMER */}

//                   <td>
//                     <div className="customer-info">
//                       <div className="customer-avatar">
//                         <FaUser />
//                       </div>

//                       <div>
//                         <strong>{request.name || "Unknown Customer"}</strong>

//                         <span>{request.email || "No email"}</span>
//                       </div>
//                     </div>
//                   </td>

//                   {/* CONTACT */}

//                   <td>
//                     <div className="contact-info">
//                       {request.phone && (
//                         <a href={`tel:${request.phone}`}>
//                           <FaPhone />

//                           {request.phone}
//                         </a>
//                       )}

//                       {request.whatsapp && (
//                         <a
//                           href={`https://wa.me/${String(
//                             request.whatsapp,
//                           ).replace(/\D/g, "")}`}
//                           target="_blank"
//                           rel="noreferrer"
//                           className="whatsapp-link"
//                         >
//                           <FaWhatsapp />
//                           WhatsApp
//                         </a>
//                       )}
//                     </div>
//                   </td>

//                   {/* PROJECT */}

//                   <td>
//                     <div className="project1-info">
//                       <strong>{request.sport || "Not specified"}</strong>

//                       <span>{request.surface || "Surface not specified"}</span>
//                     </div>
//                   </td>

//                   {/* LOCATION */}

//                   <td>
//                     <div className="location-info">
//                       <FaMapMarkerAlt />

//                       <span>
//                         {request.city ||
//                           request.location ||
//                           request.address ||
//                           "Not specified"}
//                       </span>
//                     </div>
//                   </td>

//                   {/* DATE */}

//                   <td>
//                     <span className="request-date">
//                       {formatDate(request.createdAt)}
//                     </span>
//                   </td>

//                   {/* STATUS */}

//                   <td>
//                     <select
//                       className={`request-status status-${(
//                         request.status || "new"
//                       ).toLowerCase()}`}
//                       value={request.status || "New"}
//                       onChange={(e) => updateStatus(request.id, e.target.value)}
//                     >
//                       <option value="New">New</option>

//                       <option value="Contacted">Contacted</option>

//                       <option value="Quoted">Quoted</option>

//                       <option value="Closed">Closed</option>
//                     </select>
//                   </td>

//                   {/* ACTIONS */}

//                   <td>
//                     <div className="quote-actions">
//                       <button
//                         type="button"
//                         className="view-btn"
//                         title="View Request"
//                         onClick={() => setSelectedRequest(request)}
//                       >
//                         <FaEye />
//                       </button>

//                       <button
//                         type="button"
//                         className="delete-btn"
//                         title="Delete Request"
//                         onClick={() => handleDelete(request.id)}
//                       >
//                         <FaTrash />
//                       </button>
//                     </div>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       )}

//       {/* ======================================
//           DETAILS MODAL
//       ====================================== */}

//       {selectedRequest && (
//         <div
//           className="quote-modal-overlay"
//           onClick={() => setSelectedRequest(null)}
//         >
//           <div className="quote-modal" onClick={(e) => e.stopPropagation()}>
//             <div className="quote-modal-header">
//               <div>
//                 <span>Quote Request</span>

//                 <h2>{selectedRequest.name || "Customer"}</h2>
//               </div>

//               <button
//                 type="button"
//                 className="quote-modal-close"
//                 onClick={() => setSelectedRequest(null)}
//               >
//                 <FaTimes />
//               </button>
//             </div>

//             <div className="quote-modal-body">
//               {/* CONTACT */}

//               <div className="detail-section">
//                 <h3>
//                   <FaUser />
//                   Customer Details
//                 </h3>

//                 <div className="detail-grid">
//                   <div>
//                     <label>Name</label>

//                     <strong>{selectedRequest.name || "Not provided"}</strong>
//                   </div>

//                   <div>
//                     <label>Email</label>

//                     <strong>{selectedRequest.email || "Not provided"}</strong>
//                   </div>

//                   <div>
//                     <label>Phone</label>

//                     <strong>{selectedRequest.phone || "Not provided"}</strong>
//                   </div>

//                   <div>
//                     <label>WhatsApp</label>

//                     <strong>
//                       {selectedRequest.whatsapp ||
//                         selectedRequest.phone ||
//                         "Not provided"}
//                     </strong>
//                   </div>
//                 </div>
//               </div>

//               {/* PROJECT */}

//               <div className="detail-section">
//                 <h3>
//                   <FaFileInvoiceDollar />
//                   Project Details
//                 </h3>

//                 <div className="detail-grid">
//                   <div>
//                     <label>Sport</label>

//                     <strong>{selectedRequest.sport || "Not provided"}</strong>
//                   </div>

//                   <div>
//                     <label>Surface</label>

//                     <strong>{selectedRequest.surface || "Not provided"}</strong>
//                   </div>

//                   <div>
//                     <label>Area</label>

//                     <strong>
//                       {selectedRequest.area
//                         ? `${selectedRequest.area} sq.ft`
//                         : "Not provided"}
//                     </strong>
//                   </div>

//                   <div>
//                     <label>Budget</label>

//                     <strong>{selectedRequest.budget || "Not provided"}</strong>
//                   </div>
//                 </div>
//               </div>

//               {/* LOCATION */}

//               <div className="detail-section">
//                 <h3>
//                   <FaMapMarkerAlt />
//                   Location
//                 </h3>

//                 <p className="detail-text">
//                   {selectedRequest.address ||
//                     selectedRequest.location ||
//                     selectedRequest.city ||
//                     "No location provided."}
//                 </p>
//               </div>

//               {/* MESSAGE */}

//               <div className="detail-section">
//                 <h3>
//                   <FaCommentAlt />
//                   Customer Message
//                 </h3>

//                 <p className="detail-message">
//                   {selectedRequest.message ||
//                     selectedRequest.description ||
//                     "No message provided."}
//                 </p>
//               </div>

//               {/* DATE */}

//               <div className="detail-section">
//                 <h3>Request Information</h3>

//                 <div className="request-information">
//                   <span>Submitted:</span>

//                   <strong>{formatDate(selectedRequest.createdAt)}</strong>
//                 </div>

//                 <div className="request-information">
//                   <span>Status:</span>

//                   <strong>{selectedRequest.status || "New"}</strong>
//                 </div>
//               </div>
//             </div>

//             {/* MODAL FOOTER */}

//             <div className="quote-modal-footer">
//               {selectedRequest.phone && (
//                 <a
//                   href={`tel:${selectedRequest.phone}`}
//                   className="modal-call-btn"
//                 >
//                   <FaPhone />
//                   Call Customer
//                 </a>
//               )}

//               {(selectedRequest.whatsapp || selectedRequest.phone) && (
//                 <a
//                   href={`https://wa.me/${String(
//                     selectedRequest.whatsapp || selectedRequest.phone,
//                   ).replace(/\D/g, "")}`}
//                   target="_blank"
//                   rel="noreferrer"
//                   className="modal-whatsapp-btn"
//                 >
//                   <FaWhatsapp />
//                   WhatsApp
//                 </a>
//               )}

//               {selectedRequest.email && (
//                 <a
//                   href={`mailto:${selectedRequest.email}`}
//                   className="modal-email-btn"
//                 >
//                   <FaEnvelope />
//                   Email Customer
//                 </a>
//               )}
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default QuoteRequests;
import React, { useEffect, useMemo, useState } from "react";

import {
  collection,
  deleteDoc,
  doc,
  onSnapshot,
  orderBy,
  query,
  updateDoc,
} from "firebase/firestore";

import {
  FaSearch,
  FaPhone,
  FaEnvelope,
  FaWhatsapp,
  FaTrash,
  FaEye,
  FaTimes,
  FaFileInvoiceDollar,
  FaUser,
  FaMapMarkerAlt,
  FaCommentAlt,
} from "react-icons/fa";

import { db } from "../../../firebase/firebase";

import "./QuoteRequests.css";

const STATUS_OPTIONS = ["New", "Contacted", "Quoted", "Closed"];

/**
 * Convert Firestore Timestamp / Date / string / seconds object
 * into a JavaScript Date.
 */
const toDate = (timestamp) => {
  if (!timestamp) {
    return null;
  }

  // Firebase Timestamp
  if (typeof timestamp.toDate === "function") {
    const date = timestamp.toDate();

    return isNaN(date.getTime()) ? null : date;
  }

  // Firestore timestamp-like object
  if (timestamp.seconds) {
    const date = new Date(timestamp.seconds * 1000);

    return isNaN(date.getTime()) ? null : date;
  }

  // JS Date / string
  const date = new Date(timestamp);

  return isNaN(date.getTime()) ? null : date;
};

/**
 * Format Firestore date for display.
 */
const formatDate = (timestamp) => {
  const date = toDate(timestamp);

  if (!date) {
    return "No date";
  }

  return date.toLocaleString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

/**
 * Normalize status values coming from Firestore.
 *
 * This protects the UI if an old/invalid status exists.
 */
const normalizeStatus = (status) => {
  if (STATUS_OPTIONS.includes(status)) {
    return status;
  }

  return "New";
};

/**
 * Convert a phone/WhatsApp number into a WhatsApp-compatible number.
 *
 * Example:
 * +91 98765 43210 → 919876543210
 * 9876543210      → 919876543210
 */
const getWhatsAppNumber = (number) => {
  if (!number) {
    return "";
  }

  let digits = String(number).replace(/\D/g, "");

  // Indian 10-digit number
  if (digits.length === 10) {
    digits = `91${digits}`;
  }

  // Remove leading 00 from international numbers
  if (digits.startsWith("00")) {
    digits = digits.substring(2);
  }

  return digits;
};

const QuoteRequests = () => {
  const [requests, setRequests] = useState([]);
  const [search, setSearch] = useState("");

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const [selectedRequestId, setSelectedRequestId] = useState(null);

  const [updatingStatusId, setUpdatingStatusId] = useState(null);
  const [deletingRequestId, setDeletingRequestId] = useState(null);

  // =========================================================
  // FIRESTORE LISTENER
  // =========================================================

  useEffect(() => {
    setLoading(true);
    setError("");

    const requestsQuery = query(
      collection(db, "quoteRequests"),
      orderBy("createdAt", "desc"),
    );

    const unsubscribe = onSnapshot(
      requestsQuery,
      (snapshot) => {
        const data = snapshot.docs.map((item) => ({
          id: item.id,
          ...item.data(),
        }));

        setRequests(data);
        setLoading(false);
      },
      (firebaseError) => {
        console.error("Error loading quote requests:", firebaseError);

        setError(
          "Unable to load quote requests. Please check your connection or try again.",
        );

        setLoading(false);
      },
    );

    return () => {
      unsubscribe();
    };
  }, []);

  // =========================================================
  // SELECTED REQUEST
  // =========================================================
  //
  // We store only the ID.
  //
  // This means if Firestore updates the request while the modal
  // is open, the modal automatically receives the latest data.
  // =========================================================

  const selectedRequest = useMemo(() => {
    if (!selectedRequestId) {
      return null;
    }

    return requests.find((request) => request.id === selectedRequestId) || null;
  }, [requests, selectedRequestId]);

  // =========================================================
  // ESCAPE KEY
  // =========================================================

  useEffect(() => {
    if (!selectedRequest) {
      return;
    }

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        setSelectedRequestId(null);
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [selectedRequest]);

  // =========================================================
  // SEARCH
  // =========================================================

  const filteredRequests = useMemo(() => {
    const searchText = search.trim().toLowerCase();

    if (!searchText) {
      return requests;
    }

    return requests.filter((request) => {
      const searchableFields = [
        request.name,
        request.email,
        request.phone,
        request.whatsapp,
        request.sport,
        request.surface,
        request.city,
        request.location,
        request.address,
        request.budget,
        request.message,
        request.description,
      ];

      return searchableFields
        .filter(Boolean)
        .some((value) => String(value).toLowerCase().includes(searchText));
    });
  }, [requests, search]);

  // =========================================================
  // UPDATE STATUS
  // =========================================================

  const updateStatus = async (id, status) => {
    if (!id || !STATUS_OPTIONS.includes(status)) {
      return;
    }

    try {
      setUpdatingStatusId(id);

      await updateDoc(doc(db, "quoteRequests", id), {
        status,
      });
    } catch (firebaseError) {
      console.error("Error updating quote status:", firebaseError);

      alert("Unable to update request status.");
    } finally {
      setUpdatingStatusId(null);
    }
  };

  // =========================================================
  // DELETE REQUEST
  // =========================================================

  const handleDelete = async (id) => {
    if (!id || deletingRequestId) {
      return;
    }

    const confirmDelete = window.confirm(
      "Are you sure you want to permanently delete this quote request?",
    );

    if (!confirmDelete) {
      return;
    }

    try {
      setDeletingRequestId(id);

      await deleteDoc(doc(db, "quoteRequests", id));

      // Close modal if deleted request is currently open.
      if (selectedRequestId === id) {
        setSelectedRequestId(null);
      }
    } catch (firebaseError) {
      console.error("Error deleting quote request:", firebaseError);

      alert("Unable to delete this request.");
    } finally {
      setDeletingRequestId(null);
    }
  };

  // =========================================================
  // CLOSE MODAL
  // =========================================================

  const closeModal = () => {
    setSelectedRequestId(null);
  };

  // =========================================================
  // LOADING
  // =========================================================

  if (loading) {
    return (
      <div className="quote-loading">
        <div className="quote-spinner" aria-hidden="true"></div>

        <p>Loading quote requests...</p>
      </div>
    );
  }

  // =========================================================
  // ERROR
  // =========================================================

  if (error) {
    return (
      <div className="quote-page">
        <div className="quote-error">
          <div className="quote-empty-icon">
            <FaFileInvoiceDollar />
          </div>

          <h3>Unable to Load Requests</h3>

          <p>{error}</p>

          <button
            type="button"
            className="quote-retry-btn"
            onClick={() => window.location.reload()}
          >
            Try Again
          </button>
        </div>
      </div>
    );
  }

  // =========================================================
  // PAGE
  // =========================================================

  return (
    <div className="quote-page">
      {/* =====================================================
          HEADER
      ===================================================== */}

      <div className="quote-header">
        <div>
          <div className="quote-title-row">
            <FaFileInvoiceDollar aria-hidden="true" />

            <h2>Quote Requests</h2>
          </div>

          <p>Manage customer quote enquiries from your website.</p>
        </div>

        <div className="quote-total">
          <strong>{requests.length}</strong>

          <span>Total Requests</span>
        </div>
      </div>

      {/* =====================================================
          TOOLBAR
      ===================================================== */}

      <div className="quote-toolbar">
        <div className="quote-search">
          <FaSearch aria-hidden="true" />

          <input
            type="text"
            placeholder="Search by name, email, phone, sport or location..."
            value={search}
            onChange={(event) => setSearch(event.target.value)}
            aria-label="Search quote requests"
          />

          {search && (
            <button
              type="button"
              className="quote-search-clear"
              onClick={() => setSearch("")}
              aria-label="Clear search"
              title="Clear search"
            >
              <FaTimes />
            </button>
          )}
        </div>

        <div className="quote-count">
          {filteredRequests.length}{" "}
          {filteredRequests.length === 1 ? "Request" : "Requests"}
        </div>
      </div>

      {/* =====================================================
          EMPTY STATE
      ===================================================== */}

      {filteredRequests.length === 0 && (
        <div className="quote-empty">
          <div className="quote-empty-icon">
            <FaFileInvoiceDollar />
          </div>

          <h3>{search ? "No Requests Found" : "No Quote Requests Yet"}</h3>

          <p>
            {search
              ? "Try another search."
              : "Customer quote enquiries will appear here."}
          </p>

          {search && (
            <button
              type="button"
              className="quote-clear-search-btn"
              onClick={() => setSearch("")}
            >
              Clear Search
            </button>
          )}
        </div>
      )}

      {/* =====================================================
          REQUEST TABLE
      ===================================================== */}

      {filteredRequests.length > 0 && (
        <div className="quote-table-wrapper">
          <table className="quote-table">
            <thead>
              <tr>
                <th>Customer</th>
                <th>Contact</th>
                <th>Project</th>
                <th>Location</th>
                <th>Date</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>

            <tbody>
              {filteredRequests.map((request) => {
                const status = normalizeStatus(request.status);

                const whatsappNumber = getWhatsAppNumber(
                  request.whatsapp || request.phone,
                );

                const isUpdating = updatingStatusId === request.id;

                const isDeleting = deletingRequestId === request.id;

                return (
                  <tr key={request.id}>
                    {/* =================================================
                        CUSTOMER
                    ================================================= */}

                    <td>
                      <div className="customer-info">
                        <div className="customer-avatar">
                          <FaUser aria-hidden="true" />
                        </div>

                        <div>
                          <strong>{request.name || "Unknown Customer"}</strong>

                          {request.email ? (
                            <a
                              href={`mailto:${request.email}`}
                              className="customer-email"
                            >
                              {request.email}
                            </a>
                          ) : (
                            <span>No email</span>
                          )}
                        </div>
                      </div>
                    </td>

                    {/* =================================================
                        CONTACT
                    ================================================= */}

                    <td>
                      <div className="contact-info">
                        {request.phone && (
                          <a
                            href={`tel:${request.phone}`}
                            title="Call customer"
                          >
                            <FaPhone aria-hidden="true" />
                            <span>{request.phone}</span>
                          </a>
                        )}

                        {whatsappNumber && (
                          <a
                            href={`https://wa.me/${whatsappNumber}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="whatsapp-link"
                            title="Open WhatsApp"
                          >
                            <FaWhatsapp aria-hidden="true" />
                            <span>WhatsApp</span>
                          </a>
                        )}

                        {!request.phone && !request.whatsapp && (
                          <span className="no-contact">No contact</span>
                        )}
                      </div>
                    </td>

                    {/* =================================================
                        PROJECT
                    ================================================= */}

                    <td>
                      <div className="project-info">
                        <strong>{request.sport || "Not specified"}</strong>

                        <span>
                          {request.surface || "Surface not specified"}
                        </span>
                      </div>
                    </td>

                    {/* =================================================
                        LOCATION
                    ================================================= */}

                    <td>
                      <div className="location-info">
                        <FaMapMarkerAlt aria-hidden="true" />

                        <span>
                          {request.city ||
                            request.location ||
                            request.address ||
                            "Not specified"}
                        </span>
                      </div>
                    </td>

                    {/* =================================================
                        DATE
                    ================================================= */}

                    <td>
                      <span className="request-date">
                        {formatDate(request.createdAt)}
                      </span>
                    </td>

                    {/* =================================================
                        STATUS
                    ================================================= */}

                    <td>
                      <select
                        className={`request-status status-${status.toLowerCase()}`}
                        value={status}
                        disabled={isUpdating}
                        onChange={(event) =>
                          updateStatus(request.id, event.target.value)
                        }
                        aria-label={`Status for ${request.name || "customer"}`}
                      >
                        {STATUS_OPTIONS.map((statusOption) => (
                          <option key={statusOption} value={statusOption}>
                            {statusOption}
                          </option>
                        ))}
                      </select>
                    </td>

                    {/* =================================================
                        ACTIONS
                    ================================================= */}

                    <td>
                      <div className="quote-actions">
                        <button
                          type="button"
                          className="view-btn"
                          title="View Request"
                          aria-label={`View request from ${
                            request.name || "customer"
                          }`}
                          onClick={() => setSelectedRequestId(request.id)}
                        >
                          <FaEye aria-hidden="true" />
                        </button>

                        <button
                          type="button"
                          className="delete-btn"
                          title={isDeleting ? "Deleting..." : "Delete Request"}
                          aria-label={`Delete request from ${
                            request.name || "customer"
                          }`}
                          disabled={isDeleting}
                          onClick={() => handleDelete(request.id)}
                        >
                          <FaTrash aria-hidden="true" />
                        </button>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}

      {/* =====================================================
          DETAILS MODAL
      ===================================================== */}

      {selectedRequest && (
        <div
          className="quote-modal-overlay"
          onClick={closeModal}
          role="presentation"
        >
          <div
            className="quote-modal"
            role="dialog"
            aria-modal="true"
            aria-labelledby="quote-modal-title"
            onClick={(event) => event.stopPropagation()}
          >
            {/* =================================================
                MODAL HEADER
            ================================================= */}

            <div className="quote-modal-header">
              <div>
                <span>Quote Request</span>

                <h2 id="quote-modal-title">
                  {selectedRequest.name || "Customer"}
                </h2>
              </div>

              <button
                type="button"
                className="quote-modal-close"
                onClick={closeModal}
                aria-label="Close request details"
                title="Close"
              >
                <FaTimes aria-hidden="true" />
              </button>
            </div>

            {/* =================================================
                MODAL BODY
            ================================================= */}

            <div className="quote-modal-body">
              {/* ===============================================
                  CUSTOMER DETAILS
              =============================================== */}

              <div className="detail-section">
                <h3>
                  <FaUser aria-hidden="true" />
                  Customer Details
                </h3>

                <div className="detail-grid">
                  <div>
                    <label>Name</label>

                    <strong>{selectedRequest.name || "Not provided"}</strong>
                  </div>

                  <div>
                    <label>Email</label>

                    {selectedRequest.email ? (
                      <a
                        href={`mailto:${selectedRequest.email}`}
                        className="detail-link"
                      >
                        {selectedRequest.email}
                      </a>
                    ) : (
                      <strong>Not provided</strong>
                    )}
                  </div>

                  <div>
                    <label>Phone</label>

                    {selectedRequest.phone ? (
                      <a
                        href={`tel:${selectedRequest.phone}`}
                        className="detail-link"
                      >
                        {selectedRequest.phone}
                      </a>
                    ) : (
                      <strong>Not provided</strong>
                    )}
                  </div>

                  <div>
                    <label>WhatsApp</label>

                    {selectedRequest.whatsapp || selectedRequest.phone ? (
                      <a
                        href={`https://wa.me/${getWhatsAppNumber(
                          selectedRequest.whatsapp || selectedRequest.phone,
                        )}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="detail-link whatsapp-detail-link"
                      >
                        {selectedRequest.whatsapp || selectedRequest.phone}
                      </a>
                    ) : (
                      <strong>Not provided</strong>
                    )}
                  </div>
                </div>
              </div>

              {/* ===============================================
                  PROJECT DETAILS
              =============================================== */}

              <div className="detail-section">
                <h3>
                  <FaFileInvoiceDollar aria-hidden="true" />
                  Project Details
                </h3>

                <div className="detail-grid">
                  <div>
                    <label>Sport</label>

                    <strong>{selectedRequest.sport || "Not provided"}</strong>
                  </div>

                  <div>
                    <label>Surface</label>

                    <strong>{selectedRequest.surface || "Not provided"}</strong>
                  </div>

                  <div>
                    <label>Area</label>

                    <strong>
                      {selectedRequest.area
                        ? `${selectedRequest.area} sq.ft`
                        : "Not provided"}
                    </strong>
                  </div>

                  <div>
                    <label>Budget</label>

                    <strong>{selectedRequest.budget || "Not provided"}</strong>
                  </div>
                </div>
              </div>

              {/* ===============================================
                  LOCATION
              =============================================== */}

              <div className="detail-section">
                <h3>
                  <FaMapMarkerAlt aria-hidden="true" />
                  Location
                </h3>

                <p className="detail-text">
                  {selectedRequest.address ||
                    selectedRequest.location ||
                    selectedRequest.city ||
                    "No location provided."}
                </p>
              </div>

              {/* ===============================================
                  CUSTOMER MESSAGE
              =============================================== */}

              <div className="detail-section">
                <h3>
                  <FaCommentAlt aria-hidden="true" />
                  Customer Message
                </h3>

                <p className="detail-message">
                  {selectedRequest.message ||
                    selectedRequest.description ||
                    "No message provided."}
                </p>
              </div>

              {/* ===============================================
                  REQUEST INFORMATION
              =============================================== */}

              <div className="detail-section">
                <h3>Request Information</h3>

                <div className="request-information">
                  <span>Submitted:</span>

                  <strong>{formatDate(selectedRequest.createdAt)}</strong>
                </div>

                <div className="request-information">
                  <span>Status:</span>

                  <strong>{normalizeStatus(selectedRequest.status)}</strong>
                </div>

                {selectedRequest.id && (
                  <div className="request-information">
                    <span>Request ID:</span>

                    <strong className="request-id">{selectedRequest.id}</strong>
                  </div>
                )}
              </div>
            </div>

            {/* =================================================
                MODAL FOOTER
            ================================================= */}

            <div className="quote-modal-footer">
              {selectedRequest.phone && (
                <a
                  href={`tel:${selectedRequest.phone}`}
                  className="modal-call-btn"
                >
                  <FaPhone aria-hidden="true" />
                  <span>Call Customer</span>
                </a>
              )}

              {(selectedRequest.whatsapp || selectedRequest.phone) && (
                <a
                  href={`https://wa.me/${getWhatsAppNumber(
                    selectedRequest.whatsapp || selectedRequest.phone,
                  )}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="modal-whatsapp-btn"
                >
                  <FaWhatsapp aria-hidden="true" />
                  <span>WhatsApp</span>
                </a>
              )}

              {selectedRequest.email && (
                <a
                  href={`mailto:${selectedRequest.email}`}
                  className="modal-email-btn"
                >
                  <FaEnvelope aria-hidden="true" />
                  <span>Email Customer</span>
                </a>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default QuoteRequests;
